<template>
  <v-dialog v-model="show" width="40vw" scrollable>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"
        >Muestra en laboratorios
      </v-card-title>
      <v-card-text>
        <div v-if="isLoading">
          <v-row class="text-start mt-2">
            <v-col>
              <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <span class="font-weight-bold font-italic ml-5"
                >Cargando muestras en laboratorio...</span
              >
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
            <v-timeline-item
              fill-dot
              v-for="(lab, i) in labs"
              :key="i"
              color="primary"
              icon="mdi-hand-extended"
            >
              <v-card color="primary" dark>
                <v-card-title class="text-subtitle-1">
                  {{ lab.laboratory.name }}
                </v-card-title>
                <v-card-text class="white text--primary">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <span class="text-caption font-weight-bold font-italic">
                        {{ lab.laboratory.name }}, {{ lab.laboratory.city }},
                        {{ lab.laboratory.state }},{{ lab.laboratory.country }},
                        {{ lab.laboratory.zipCode }}
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
          <div v-if="!isLoading && labs.length == 0">
            <v-row class="text-center mt-2">
              <v-col>
                <span class="font-weight-bold font-italic"
                  >No hay registros de muestras en laboratorio</span
                >
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <!-- <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" dark block @click="show = false">
                Cerrar
              </v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary" block @click="show = false">
                Aceptar
              </v-btn>
            </v-col>
          </v-row>
        </v-container> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    labs: [],
    isLoading: false,
  }),
  props: {
    value: Boolean,
    analysis: Object,
  },
  computed: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("reception", ["getLabsByAnalysisRequest"]),
    async getLabsByanalysis() {
      try {
        this.isLoading = true;
        let response = await this.getLabsByAnalysisRequest({
          analysisId: this.analysis._id,
        });
        if (response) {
          if (!response.error) {
            this.labs = response.labs;
            console.log(response.labs);
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Algo salio mal al cargar muestras en laboratorio",
              timeout: 5000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Algo salio mal al cargar muestras en laboratorio",
            timeout: 5000,
          });
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar muestras en laboratorio",
          timeout: 5000,
        });
      }
      this.isLoading = false;
    },
  },
  watch: {
    async show(value) {
      if (value) {
        // DIALOG OPEN
        await this.getLabsByanalysis();
      } else {
        // DIALOG CLOSE
      }
    },
  },
};
</script>